import React from "react";
import { Button } from "react-bulma-components";
import { AlertTriangle } from "lucide-react";

const ErrorScreen = ({
  message,
  retryAfter,
  onClose,
  details,
  timestamp,
  code,
}: SystemErrorProps) => {
  if (!message) {
    return null; // If no message is provided, do not render the component
  }
  console.log("Rendering ErrorScreen with message:", message);
  console.debug("Details:", details);
  console.debug("Timestamp:", timestamp);
  console.debug("Code:", code);

  if (typeof retryAfter !== "function") {
    console.warn(
      "retryAfter is not a function, it should be a function that handles retry logic.",
    );
  }
  return (
    <div className="fixed inset-0 bg-red-900/90 flex flex-col items-center justify-center z-50 p-4">
      <AlertTriangle className="text-red-300 text-6xl mb-4" />
      <h2 className="text-red-200 text-2xl font-bold mb-4">Erro</h2>
      <p className="text-red-300 text-center mb-6 max-w-lg">{message}</p>
      {details && <p className="text-red-300 text-sm mb-2">{details}</p>}
      {timestamp && (
        <p className="text-red-300 text-xs mb-2">
          Ocorreu em: {new Date(timestamp).toLocaleString()}
        </p>
      )}
      {code && <p className="text-red-300 text-xs mb-4">Código: {code}</p>}
      {typeof retryAfter === "function" && (
        <Button onClick={retryAfter} className="is-danger">
          Tentar Novamente
        </Button>
      )}
      {!retryAfter && (
        <p className="text-red-300 text-sm mb-4">
          Por favor, tente novamente mais tarde.
        </p>
      )}
      {typeof onClose === "function" && (
        <Button onClick={onClose} className="is-light mt-4">
          Fechar
        </Button>
      )}
    </div>
  );
};

export default ErrorScreen;
